import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

const httpGetOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
    }),
    withCredentials: true
};

const httpPostOptions = {
    headers: new HttpHeaders({
        'Content-Type': 'application/json'
    }),
    withCredentials: true
};

import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { RequestOptions, ResponseContentType, Request, RequestMethod, ResponseType } from '@angular/http';
import { MessageService } from './message.service';


@Injectable({
    providedIn: 'root'
})

export class AuthService {
    private apiEndpoint = environment.apiEndpoint;
    private AuthUrl = this.apiEndpoint + 'Auth';

    constructor(private http: HttpClient,
        private messageService: MessageService) {
    }

    getUserSession(): Observable<any> {
        return this.http.get<any>(this.AuthUrl + '/GetUserSession/', httpGetOptions)
    }
}